import type { CapabilityPredicate } from '@/features/authentication/types/permissions';
import { Trans } from '@lingui/react/macro';
import { Mail, ShieldCheck, UserRound } from 'lucide-react';
import type { ReactNode } from 'react';

export interface UserManagementNavigationItem {
  label: ReactNode;
  to: '/user-management/account' | '/user-management/role' | '/user-management/invitations';
  icon: ReactNode;
  visibleWhen: CapabilityPredicate;
}

export const USER_MANAGEMENT_NAVIGATION: UserManagementNavigationItem[] = [
  {
    label: <Trans>Account</Trans>,
    to: '/user-management/account',
    icon: <UserRound size={14} />,
    visibleWhen: (has) => has('users.list'),
  },
  {
    label: <Trans>Role</Trans>,
    to: '/user-management/role',
    icon: <ShieldCheck size={14} />,
    visibleWhen: (has) => has('authz.permission-sets.list'),
  },
  {
    label: <Trans>Invitations</Trans>,
    to: '/user-management/invitations',
    icon: <Mail size={14} />,
    visibleWhen: (has) => has('organization-members.list') && has('organizations.list'),
  },
];
